import React, { useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Mensaje } from "../mensajes2";
import { Dimmer } from "../spinner";
import { validaSoloNumero, formatMoneda } from "../../util/varios";
import "react-tabs/style/react-tabs.css";
import axios from "axios";
import CatalogoFondoAvance from "../../catalogos/catalogoFondoAvance";
import CatalogoProveedor from "../../catalogos/catalogoProveedor";
import CatalogoContable from "../../catalogos/catalogoContable";
import moment from "moment";

import { DangerButton, SuccessButton, PrimaryButton } from "../../ui/buttons/Button";
import { Input, SearchInput } from "../../ui/inputs/Input";
import { Button } from "react-bootstrap";

export const ModalVincularAvance = (props) => {
  let op = require("../../../src/modulos/datos");
  const idefiscal = JSON.parse(localStorage.getItem("idefiscal"));

  const btnCancela = useRef();
  const btnAcepta = useRef();

  const txtFecha = useRef();
  const txtId2 = useRef();
  const txtDescrip2 = useRef();
  const txtMonto2 = useRef();
  const txtId3 = useRef();
  const txtDescrip3 = useRef();
  const txtId4 = useRef();
  const txtDescrip4 = useRef();

  const [mostrar, setMostrar] = useState(false);
  const [mostrar2, setMostrar2] = useState(false);
  const [mostrar3, setMostrar3] = useState(false);
  const [tieneCuenta, setTieneCuenta] = useState(false);

  const [titulo, setTitulo] = useState();
  const [msg, setMsg] = useState();
  const [activate, setActivate] = useState(false);
  const [deshabilitado, setDeshabilitado] = useState(1);
  const [habilitado, setHabilitado] = useState(0);
  const [deshabilitadoCta, setDeshabilitadoCta] = useState(true);
  const [operacion, setOperacion] = useState(0);
  const [visible, setVisible] = useState(false);
  const txtId = useRef();
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });

  let token = localStorage.getItem("jwtToken");
  const actualizar = (operacion) => {
    let endpoint;
    if (!tieneCuenta) {
      endpoint = `${op.conexion}/api/contabilidadfis/vincularfondo1`;
    } else {
      endpoint = `${op.conexion}/api/contabilidadfis/vincularfondo2`;
    }
    let body;
    setActivate(true);
    body = {
      idcuenta: txtId4.current.value,
      idfondo: txtId.current.value,
      idefiscal: idefiscal,
    };
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setMensaje({
            mostrar: true,
            titulo: "Exito.",
            texto: "registro creado correctamente.",
            icono: "exito",
          });
        }
        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const validarCampos = (e) => {
    e.preventDefault();
    var sigue = true;
    if (txtId4.current.value.trim() === "" || txtDescrip4.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "No se ha Seleccionado Ninguna Cuenta.",
        icono: "informacion",
      });
      sigue = false;
      txtId4.current.focus();
    } else if (sigue === true) {
      actualizar();
    }
  };

  const cerrarModal = () => {
    blanquearCampos();
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });

    //props.setShow(false);
  };

  const blanquearCampos = () => {
    setDeshabilitado(1);
    setMostrar(false);
    setTitulo("");
    setMsg("");
    txtId.current.value = "";
    txtFecha.current.value = "";
    txtId2.current.value = "";
    txtDescrip2.current.value = "";
    txtId3.current.value = "";
    txtDescrip3.current.value = "";
    txtId4.current.value = "";
    txtDescrip4.current.value = "";
    setActivate(false);
    setOperacion();
    setActivate(false);
    setOperacion();
    setDeshabilitado(1);
    setHabilitado(0);
    setDeshabilitadoCta(true);
    setVisible();
  };

  const salir = () => {
    setDeshabilitado(1);
    props.setShow(false);
    blanquearCampos();
  };

  const seleccionarProveedor = (id) => {
    setMostrar2(false);
    let campos = "*";
    let nomtab = "proveedor";
    let nomid = "idproveedor";

    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${id}&nomtab=${nomtab}&nomid=${nomid}`;
    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          console.log(response.data);
          txtId3.current.value = response.data.idproveedor;
          txtDescrip3.current.value = response.data.razonsocial;
        }
        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });

        setActivate(false);
      });
  };

  const seleccionarCunta = (id) => {
    let endpoint = `${op.conexion}/api/contabilidadfis/detallefondo?idfondo=${id}&idefiscal=${idefiscal}`;
    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data !== "") {
            console.log(response.data);

            txtId4.current.value = response.data.idcuentacontable;
            txtDescrip4.current.value = response.data.descripcion;

            setActivate(false);
            setTieneCuenta(true);
          } else {
            setActivate(false);
            setTieneCuenta(false);
          }
        }
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const selecionarRegistro = (id) => {
    setMostrar(false);
    let campos = "*";
    let nomtab = "fondoavance";
    let nomid = "idfondo";
    let nomid2 = "idefiscal";
    let endpoint = `${op.conexion}/api/consulta/modeli2?campos=${campos}&id=${id}&nomtab=${nomtab}&nomid=${nomid}&nomid2=${nomid2}&id2=${idefiscal}`;
    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          txtId.current.value = response.data[0].idfondo;
          txtFecha.current.value = moment.utc(response.data[0].fecha).format(
            "DD-MM-YYYY"
          );
          txtId2.current.value = response.data[0].idfondo;
          txtMonto2.current.value = formatMoneda(
            response.data[0].monto.toString().replace(".", ","),
            ",",
            ".",
            2
          );
          txtDescrip2.current.value = response.data[0].descripcion;
          seleccionarProveedor(response.data[0].idorganismo);
          seleccionarCunta(response.data[0].idfondo);
          setDeshabilitado(0);
          setDeshabilitadoCta(false);
          txtId4.current.focus();
          setHabilitado(0);
          
        }
        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const validarFondoAvance = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        selecionarRegistro(event.target.value);
      } else {
        txtId.current.value = "";
      }
    }
  };

  const validarProveedor = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        seleccionarProveedor(event.target.value);
      } else {
        txtId3.current.value = "";
        txtDescrip3.current.value = "";
      }
    }
  };

  const seleccionarCuenta = (id) => {
    setMostrar3(false);
    let endpoint = `${op.conexion}/api/contabilidadfis/selectctaconta?id=${id}&idefiscal=${idefiscal}`;
    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data !== "") {
            txtId4.current.value = response.data.idcuentacontable;
            txtDescrip4.current.value = response.data.descripcion;
            setActivate(false);
          } else {
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "No existe una Cuenta Contable con este Codigo.",
              icono: "informacion",
            });
            setActivate(false);
          }
        }
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const validarCuenta = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    txtDescrip4.current.value = "";
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        seleccionarCuenta(event.target.value);
      } else {
      }
    }
  };

  const handleVincular = (event) => {
    event.preventDefault();
    setHabilitado(1);
    setDeshabilitado(0);
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {
        setDeshabilitado(1);
        setVisible(false);
      }}
    >
      <Modal.Header className="azulGradiant">
        <h3 className="m-0 fw-bold">Vinculación de Fondo de Avance</h3>
        <a
          type="button"
          ref={btnCancela}
          className="fw-bold text-light fs-6"
          onClick={salir}
        >
          Salir <i className="fa fa-times ms-2"></i>
        </a>
      </Modal.Header>
      <Modal.Body className="d-flex flex-wrap justify-content-between">
        <div className="col-4 m-0 mb-2 p-0">
          <SearchInput
            label="Código:"
            name="idcuentabancaria"
            disabled = {habilitado === 1 ? false : true}
            disabledButton = {habilitado === 1 ? false : true}
            onKeyUp={validarFondoAvance}
            onBlur={validarFondoAvance}
            onClickButton={() => {
              setMostrar(true);
            }}
            ref={txtId}
          />
        </div>
        <div className="col-4 m-0 mb-2 p-0">
          <Input
            label="Fecha de Asignación:"
            type="date"
            name="idcuentabancaria"
            disabled
            ref={txtFecha}
          />
        </div>
        <fieldset className="col-12 m-0 p-2 border-azul rounded d-flex">
          <legend className="float-none w-auto m-0">
            Datos del Fondo de Avance
          </legend>

          <SearchInput 
            name="idcuentabancaria" 
            disabled
            disabledButton={true}
            ref={txtId2} />
          <Input
            disabled
            id="codigocuenta"
            name="codigocuenta"
            ref={txtDescrip2}
          />

          <Input
            disabled
            id="codigocuenta"
            name="codigocuenta"
            ref={txtMonto2}
          />
        </fieldset>
        <fieldset className="col-12 m-0 p-2 border-azul rounded d-flex">
          <legend className="float-none w-auto m-0">Datos del Organismo</legend>
          <div className="col-4 m-0 p-0">
            <SearchInput
              name="idcuentabancaria"
              disabled
              disabledButton={true}
              onKeyUp={validarProveedor}
              onBlur={validarProveedor}
              ref={txtId3}
              onClickButton={() => setMostrar(true)}
            />
          </div>
          <Input
            id="codigocuenta"
            disabled
            name="codigocuenta"
            ref={txtDescrip3}
          />
        </fieldset>
        <div className="col-12 m-0 mt-2 p-0 d-flex">
          <div className="col-4 m-0 p-0">
            <SearchInput
              label="Código Cuenta:"
              name="idcuentabancaria"
              disabled={deshabilitadoCta}
              disabledButton={deshabilitadoCta}
              onKeyUp={validarCuenta}
              onBlur={validarCuenta}
              onClickButton={() => setMostrar3(true)}
              ref={txtId4}
            />
          </div>
          <Input
            id="codigocuenta"
            disabled
            name="codigocuenta"
            ref={txtDescrip4}
          />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <PrimaryButton
          disabled={deshabilitado === 1 ? false : true}
          onClick={handleVincular}
          icon="fa-pen-nib"
        //ref={btnAcepta}
        >
          Vincular
        </PrimaryButton>
        <SuccessButton
          disabled={deshabilitadoCta}
          onClick={validarCampos}
          ref={btnAcepta}
        >
          Aceptar
        </SuccessButton>
        <Button
          variant="secondary rounded-pill"
          disabled={deshabilitado === 1 ? true : false}
          onClick={blanquearCampos}
          //ref={btnAcepta}
        >
          Cancelar
          <i className="fw-bold fas ms-2 fas fa-window-close me-1"></i>
        </Button>
        <DangerButton 
          onClick={salir} 
          disabled={deshabilitado === 1 ? false : true}
          icon="fa-sign-out-alt"
          //ref={btnCancela}
        >
          Salir
        </DangerButton>
      </Modal.Footer>

      <CatalogoProveedor
        show={mostrar2}
        onHideCancelaCatProv={() => {
          setMostrar2(false);
        }}
        onHideAceptaCatProv={seleccionarProveedor}
        imp={1}
      />

      <CatalogoFondoAvance
        show={mostrar}
        onHideCancela={() => {
          setMostrar(false);
        }}
        onHideAcepta={selecionarRegistro}
      />

      <CatalogoContable
        llamado={1}
        show={mostrar3}
        onHideCancela={() => {
          setMostrar3(false);
        }}
        onHideAcepta={seleccionarCuenta}
      />
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          mensaje.titulo === "Exito."
            ? cerrarModal()
            : setMensaje({
              mostrar: false,
              titulo: "",
              texto: "",
              icono: "",
            });
        }}
      />

      <Dimmer active={activate} inverted></Dimmer>
    </Modal>
  );
};
